var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXmlid2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_2_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.062,
    height: 19.17,
    viewBox: "0 0 17.062 19.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#748d6f}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-1",
    d: "M39.215 281.02a4.169 4.169 0 0 1-3.374 1.722H33.9a1.553 1.553 0 0 1-1.46-1.023 4.934 4.934 0 0 1-.785-.31 5.289 5.289 0 0 1-1.467-1.086 6.262 6.262 0 0 0-4.911 6.114v.391a.974.974 0 0 0 .974.974h15.11a.974.974 0 0 0 .974-.974v-.391a6.257 6.257 0 0 0-3.12-5.417z",
    transform: "translate(-25.274 -268.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-1",
    d: "M92.717 9.683a1.109 1.109 0 0 0 .972-.574l.015.04v.012a4.329 4.329 0 0 0 2.441 2.57 1.551 1.551 0 0 1 1.32-.731h1.944a1.088 1.088 0 0 0 .533-.143 2.2 2.2 0 0 0 .628-.725 5.605 5.605 0 0 0 .486-1.028 1.115 1.115 0 0 0 .307.353v.477a1.956 1.956 0 0 1-1.954 1.954h-1.945a.665.665 0 0 0 0 1.331h1.944a3.288 3.288 0 0 0 3.285-3.285v-.473a1.107 1.107 0 0 0 .444-.887V5.8a1.107 1.107 0 0 0-.46-.9 5.321 5.321 0 0 0-10.608 0 1.107 1.107 0 0 0-.46.9v2.773a1.11 1.11 0 0 0 1.108 1.11zm4.655-8.352a4 4 0 0 1 3.97 3.594 1.113 1.113 0 0 0-.312.385 3.8 3.8 0 0 0-7.314-.01v.007a1.113 1.113 0 0 0-.312-.385 4 4 0 0 1 3.968-3.591z",
    transform: "translate(-88.842)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlid2);
export default __webpack_public_path__ + "static/media/XMLID_2_.613a43cb.svg";
export { ForwardRef as ReactComponent };